module.exports = __webpack_public_path__ + "img/shipinzhibo.9a13b055.png";